import { createContext } from "react";
import useReportTemplates from "../hooks/data/useReportTemplates";

export interface IReportTemplatesContext extends ReturnType<typeof useReportTemplates> {

};

const ReportTemplatesContext = createContext<IReportTemplatesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default ReportTemplatesContext